export default class Login {
    constructor(email, senha) {
      this.email = email;
      this.senha = senha;
    }
  }